import PropTypes from 'prop-types'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import Container from '@material-ui/core/Container'
import Grid from '@material-ui/core/Grid'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import { useTheme } from '@material-ui/core/styles'
import Card from '@components/card-medium'
import { ListRecommendedRoot, ScrollWrap } from './list-recommended.styles'
import defaults from '../../config/defaults'

const ListRecommended = (props) => {
  const {
    headline,
    articlesCollection: { total, items },
  } = props

  const theme = useTheme()
  // To control grid spacing, which is not responsive
  const isSm = useMediaQuery(theme.breakpoints.down('sm'))
  const minCardWidth = 240
  // The point at which we should scroll
  const scrollThreshold = total > 1 ? total * minCardWidth - 32 : null
  const shouldScroll = useMediaQuery(`(max-width: ${scrollThreshold}px)`)
  const gridWidth = shouldScroll ? total * minCardWidth : null

  // Because of the number cards varies, some manual grid changes are being
  // implemented. Haven't found the right math to automate this yet, as the
  // design needs fall between breakpoints and isn't standard grid usage.
  // not currently worth the time vs just removing that requirement.
  let xsCol
  let smCol
  const minimal = 380
  if (total === 1) {
    xsCol = useMediaQuery(`(max-width: ${minimal}px)`) ? 12 : 8
    smCol = 6
  }

  if (total === 2) {
    xsCol = 6
    smCol = 5
  }

  if (total === 3) {
    xsCol = 4
    smCol = 5
  }

  return (
    <ListRecommendedRoot py={[4, 4, 6]}>
      <Container>
        <Box mb={[3, 3, 5]}>
          <Typography variant="h4" align="center">
            {headline || defaults.recommendedHeadline}
          </Typography>
        </Box>
        <ScrollWrap max={scrollThreshold}>
          <Box width={gridWidth}>
            <Grid container spacing={isSm ? 2 : 4} wrap="nowrap" justifyContent="center">
              {items.map(card => (
                <Grid item xs={xsCol} sm={smCol} md={4} key={card.sys.id}>
                  <Card {...card} variant="carouseled" />
                </Grid>
              ))}
            </Grid>
          </Box>
        </ScrollWrap>
      </Container>
    </ListRecommendedRoot>
  )
}

ListRecommended.propTypes = {
  headline: PropTypes.string,
  articlesCollection: PropTypes.shape({
    items: PropTypes.array,
    total: PropTypes.number,
  }),
}

ListRecommended.defaultProps = {
  articlesCollection: {
    items: [],
  },
}

export default ListRecommended
